import { render, staticRenderFns } from "./hailuo.vue?vue&type=template&id=466bc80f&scoped=true&"
import script from "./hailuo.vue?vue&type=script&lang=js&"
export * from "./hailuo.vue?vue&type=script&lang=js&"
import style0 from "./hailuo.vue?vue&type=style&index=0&id=466bc80f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466bc80f",
  null
  
)

export default component.exports